import { motion } from 'motion/react';

export default function CenterLineElement({ ...props }) {
  return (
    <motion.svg
      width="164"
      height="216"
      viewBox="0 0 164 216"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.929934 180.808C25.1648 202.013 113.174 237.927 150.416 194.564C187.656 151.2 135.591 23.42 80.7901 2.54847C33.7323 -15.3745 131.667 195.182 117.055 202.336C102.444 209.49 2.82942 39.6202 5.43216 29.3889C8.0341 19.1571 168.878 215.512 53.149 180.593"
        stroke="#1D1A34"
        strokeWidth="1.23333"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </motion.svg>
  );
}
